import { closingAttorneyContactCard } from '../../shared';
import type { ListingLocaleOverrides } from '../base';

export const GAOverrides: ListingLocaleOverrides = {
  locale: 'GA',
  sections: {
    propertyInfo: {
      cards: {
        propertyBeingSoldCard: {
          layout: (layout) =>
            layout.concat([
              [
                {
                  name: 'property.taxIdNumber',
                  size: 100,
                },
              ],
              [
                {
                  name: 'property.platbook',
                  size: 50,
                },
                {
                  name: 'property.pages',
                  size: 50,
                },
              ],
            ]),
          fields: {
            taxIdNumber: {
              name: 'property.taxIdNumber',
              entity: 'property',
              type: 'text',
              label: 'Property Tax ID Number',
              placeholderText: '',
            },
            platbook: {
              name: 'property.platbook',
              entity: 'property',
              type: 'text',
              label: 'Deed Book',
              placeholderText: '',
            },
            pages: {
              name: 'property.pages',
              entity: 'property',
              type: 'text',
              label: 'Page',
              placeholderText: '',
            },
          },
        },
        mlsInformationCard: {
          fields: {
            mlsAutofill: {
              action: {
                props: (props) =>
                  props.filter(
                    (prop) => prop.from !== 'property.legalDescription',
                  ),
              },
            },
          },
        },
        importantDatesCard: {
          layout: () => [
            [
              {
                name: 'contractDate',
                size: 33,
              },
              {
                name: 'listingStartDate',
                size: 33,
              },
              {
                name: 'listingEndDate',
                size: 33,
              },
            ],
            [
              {
                name: 'onMarketDate',
                size: 33,
              },
              {
                name: 'closingDate',
                size: 33,
              },
              {
                name: 'bindingAgreementDate',
                size: 33,
              },
            ],
          ],
          fields: {
            bindingAgreementDate: {
              name: 'bindingAgreementDate',
              entity: 'interaction',
              type: 'date',
              label: 'Binding Agreement Date',
              placeholderText: '',
            },
          },
        },
      },
    },
    additionalContacts: {
      cards: {
        titleOfficerContactCard: null,
        attorneyContactCard: () => closingAttorneyContactCard,
      },
    },
  },
};
